import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'

export type NewsDetailResponse = {
  article?: Record<string, unknown> | null
  guessYouLike?: Array<Record<string, unknown>>
}

type NewsDetailWrappedResponse<T> = {
  code?: number
  data?: T | null
  message?: string
  succeed?: boolean
}

export type NewsDetailStatementResponse = {
  wikicommunity?: {
    detailstatement?: {
      data?: {
        title?: string | null
        content?: string | null
        url?: string | null
      }
    }
  }
}

/** 获取新闻详情，SSR 与客户端分别复用应用统一的请求封装。 */
export const getNewsDetail = async <T = NewsDetailResponse>(slug: string) => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: api.wikibitBffGo,
    url: '/api/v4/bit/web/news/detail',
    method: 'GET' as const,
    params: {
      slug,
    },
  }

  if (import.meta.server) {
    const response = await useServerFetch<NewsDetailWrappedResponse<T>>(requestConfig)
    return response?.data ?? null
  }

  return await request<unknown, T>(requestConfig)
}

/** 获取新闻详情免责声明，保持聚合接口的 Routes 请求头约定。 */
export const getNewsDetailStatement = async <T = NewsDetailStatementResponse>() => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.testwikidatacenter : api.homeClient,
    url: `${WIKIBITWEBV1}/invoke-v3/v3`,
    method: 'POST' as const,
    data: {
      detailType: 1,
    },
    headers: {
      Routes: 'wikicommunity$detailstatement',
    },
  }

  if (import.meta.server) {
    const response = await useServerFetch<NewsDetailWrappedResponse<T>>(requestConfig)
    return response?.data ?? null
  }

  return await request<unknown, T>(requestConfig)
}
